import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="relative text-white"
          >
            <h1 className="text-6xl md:text-7xl font-bold mb-8">
              Your Recovery Journey
              <span className="block mt-4 text-3xl md:text-4xl text-blue-200">
                Step by Step with Gia
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-3xl">
              Experience how our AI companion guides your post-surgical recovery, providing personalized support and real-time monitoring when it matters most.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            className="relative"
          >
            {/* Added proper mobile spacing with mb-24 on mobile */}
            <div className="relative mx-auto max-w-[500px] mb-24 sm:mb-16">
              <div className="rounded-[40px] bg-black p-4 shadow-2xl">
                <div className="relative rounded-[28px] overflow-hidden bg-white aspect-square">
                  <img
                    src="/lovable-uploads/3b0839c6-f642-4433-97a7-87f034baa0f0.png"
                    alt="Gia - Your Digital Care Assistant"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-6 left-6">
                    <img
                      src="/lovable-uploads/6224855e-ae87-40e3-b110-9acca227eda4.png"
                      alt="Scienza Health Emblem"
                      className="w-12 h-12 sm:w-16 sm:h-16"
                    />
                  </div>
                  {/* Added more bottom padding for the text container */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 pb-8 bg-gradient-to-t from-black/60 to-transparent">
                    <h2 className="text-white font-semibold text-2xl sm:text-3xl text-center mb-1">
                      Gia
                    </h2>
                    <p className="text-white/90 text-sm sm:text-base font-normal text-center">
                      Your Digital Care Assistant
                    </p>
                  </div>
                </div>
              </div>
              {/* Adjusted positioning for the FDA badge */}
              <div className="absolute bottom-[-40px] left-1/2 transform -translate-x-1/2">
                <div className="bg-purple-500 text-white px-6 py-2 rounded-full text-lg font-medium shadow-lg whitespace-nowrap">
                  FDA Registered Device
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;